<template>
  <div class="create-promotion">
    <PmwTopProgress :start="loading" :done="!loading" color="#53B483" />

    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- Sidebar -->
      <template #sidebar>
        <SidebarBlock class="pmw-page-actions">
          <Heading element="h2" class="pmw-sidebar-title">
            Ações da página
          </Heading>

          <!-- Botão salvar só fica ativado quando o nome for preenchido -->
          <PmwButton
            :disabled="disabledSave || loading"
            :tooltipMinWidth="230"
            popperStrategy="auto"
            variation="pmw-primary"
            tooltipText="Preencha os itens com o * que indicam os campos obrigatórios para salvar."
            class="pmw-page-actions--button"
            @click="savePromotion()"
          >
            Salvar
          </PmwButton>

          <!-- Se a promocao estiver ativa -->
          <PmwButton
            v-if="status && promotionId"
            :disabled="loading"
            tooltipText="Selecione um agrupador na tabela para desativar."
            variation="red-100"
            class="pmw-page-actions--button"
            @click="showModal = true"
          >
            Desativar
          </PmwButton>

          <PmwButton
            v-else-if="!status && promotionId"
            variation="pmw-primary"
            class="pmw-page-actions--button"
            @click="reactivatePromotion(promotionId)"
          >
            Reativar
          </PmwButton>

          <!-- Botão retornar -->
          <PmwButton
            variation="blue-100"
            layout="outline"
            class="pmw-page-actions--button"
            @click="$router.push({ path: '/promocoes' })"
          >
            Voltar sem salvar
          </PmwButton>
        </SidebarBlock>
      </template>

      <!-- Conteúdo -->
      <template #content>
        <Heading element="h3" class="pmw-content-title">
          Dados do grupo de promoção
        </Heading>
        <!-- Abas para inserir o nome da promocao -->
        <Tabs>
          <template
            v-for="(tab, index) in tabs"
            v-slot:[`tab-title-${index}`]="{ title, tabObj }"
          >
            <span :key="tab.title" class="tab-title">
              <img :src="tabObj.extraData.flag" />
              {{ title }}
            </span>
          </template>
          <Tab
            v-for="tab in tabs"
            :extraData="tab"
            :key="tab.title"
            :title="tab.title"
          >
            <div class="pmw-name-input">
              <!-- Input de nome -->
              <PmwFormInput
                :value="displayNameValue(tab.dataAttribute)"
                :label="'Nome (' + tab.label + ')'"
                :maxlength="50"
                :required="tab.dataAttribute === 'pt-BR'"
                :title="tab.title"
                placeholder="Insira o nome da promoção"
                showCounter
                @input="nameHandler($event, tab.dataAttribute)"
              />
            </div>
            <div class="pmw-description-input">
              <!-- Input de nome -->
              <PmwFormInput
                :value="displayDescriptionValue(tab.dataAttribute)"
                :label="'Descrição do grupo (' + tab.label + ')'"
                :maxlength="80"
                :title="tab.title"
                :infoIcon="true"
                tooltipMinWidth="165"
                infoText="A descrição do grupo aparece de forma pública no seu site Letsbook."
                placeholder="Digite um texto de descrição"
                showCounter
                @input="descriptionHandler($event, tab.dataAttribute)"
              />
            </div>
            <SeparateLine :right="0" :left="0" />

            <div v-if="tab.title === 'PT'">
              <Heading element="h3" class="pmw-content-title__image">
                Imagem da promoção
                <PmwInfoTooltip placement="top">
                  <template #content>
                    <Paragraph class="pmw-tooltip--text">
                      Imagem/banner para uso na promoção, localizada na área de
                      promoções no seu site Letsbook
                    </Paragraph>
                    <img :src="imageExample" style="width: 430px" />
                    <div style="width: 430px">
                      <InfoPanel height="50">
                        <template #content>
                          <div class="pmw-bottom-bar">
                            <span class="pmw-bottom-bar-left"
                              >Noite de Nupicias</span
                            >
                            <span class="pmw-bottom-bar-right">
                              Ver Mais
                              <i class="pmw-bottom-bar-arrow"></i>
                            </span>
                          </div>
                        </template>
                      </InfoPanel>
                    </div>
                  </template>
                </PmwInfoTooltip>
              </Heading>

              <div class="pmw-home">
                <div class="pmw-input-file">
                  <PmwImageUpload
                    v-model="imgWeb"
                    :maxSize="1024"
                    :imageWidth="780"
                    :imageHeight="130"
                    :inputWidth="461"
                    :required="true"
                    inputTitle="Web"
                    sizeInfo="Dimensão recomendada 780 x 130"
                    inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
                    sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
                    accept=".png, .jpg"
                    inputTextBox="Arraste as imagens para cá"
                    class="pmw-input-file--web"
                    @remove="removeWebImage"
                  />
                </div>

                <div class="pmw-input-file">
                  <PmwImageUpload
                    v-model="imgMobile"
                    :maxSize="1024"
                    :imageWidth="335"
                    :imageHeight="122"
                    :inputWidth="461"
                    inputTitle="Mobile"
                    sizeInfo="Dimensão recomendada 335 x 122"
                    minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 355x122 pixels. Tente novamente com uma imagem maior."
                    inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
                    sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
                    accept=".png, .jpg"
                    inputTextBox="Arraste as imagens para cá"
                    class="pmw-input-file--mobile"
                    @remove="removeMobileImage"
                  />
                </div>
              </div>
            </div>

            <SeparateLine
              v-if="tab.title === 'PT'"
              :right="0"
              :left="0"
              :bottom="30"
              :top="30"
            />

            <div v-if="tab.title === 'PT'">
              <Heading element="h3" class="pmw-content-title">
                Tarifas da promoção
              </Heading>
              <Paragraph class="pmw-content-title">
                Selecione as tarifas promocionais desejadas. Caso uma tarifa
                "<span class="pmw-content-text__danger">Não pública</span>" seja
                selecionada, ela será exibida no site.
              </Paragraph>

              <span class="form">
                <PmwSelectionBoxScroll
                  v-model="selectedRates"
                  :list="formatRateItems"
                  :buffer="100"
                  comparisonKey="codigo"
                  placeholder="Busque pelo nome da tarifa"
                  selectedPlaceholder="Busque pelo nome da tarifa selecionada"
                  titleFirstBox="Adicionar tarifas do grupo"
                  titleSecondBox="Tarifas selecionadas"
                  class="scroll-container"
                  @searchItem="searchedItem"
                  @update="onUpdate"
                >
                  <template #inputCheckboxLabel="{ label, inputValue }">
                    {{ label }}
                    <span
                      v-if="inputValue.publica"
                      class="pmw-selection-box--active"
                    >
                      (Pública)
                    </span>
                    <span v-else class="pmw-selection-box--disable">
                      (Não Pública)
                    </span>
                  </template>

                  <template #recycle-selection-box--empty-text-selection>
                    <p v-if="!loadOptions" class="empty-text">
                      Nenhuma tarifa selecionada para esse grupo de tarifas.<br />
                    </p>
                    <p v-else-if="loadOptions" class="pmw-loader"></p>
                  </template>
                </PmwSelectionBoxScroll>
                <SeparateLine :right="0" :left="0" />
              </span>
            </div>
          </Tab>
        </Tabs>

        <!-- Botões no rodapé da página -->
        <span class="pmw-bottom-action">
          <PmwButton
            variation="blue-100"
            layout="outline"
            class="pmw-bottom-action--button"
            @click="$router.push({ path: '/promocoes' })"
          >
            Voltar sem salvar
          </PmwButton>

          <!-- Botão salvar só fica ativo quando o nome for preenchido -->
          <PmwButton
            :disabled="disabledSave || loading"
            popperStrategy="absolute"
            variation="pmw-primary"
            tooltipText="Preencha os itens com o *(asterisco) que indicam os campos obrigatórios para salvar."
            class="pmw-bottom-action--button"
            @click="savePromotion()"
          >
            Salvar
          </PmwButton>
        </span>
      </template>
    </SidebarLayout3>
    <!-- Modal de deleção -->
    <AlertModal
      v-model="showModal"
      :buttonClose="true"
      title="Desativar agrupador de promoção"
      @alert-modal-confirm="inactivatePromotion()"
    >
      <template #text>
        Ao desativar essa promoção, ela não será <br />
        mais listada nos hotéis/quartos que a utilizem. <br />
        Tem certeza de que quer fazer isso?
      </template>
    </AlertModal>
  </div>
</template>

<script>
/** Bandeiras de idiomas */
import en from '@/assets/images/en-flag.png'
import es from '@/assets/images/es-flag.png'
import pt from '@/assets/images/ptbr-flag.png'

/** Imagem Exemplo */
import imageExample from '@/assets/images/imageTooltipExample.svg'

/** Componentes */

/** Locais */
import SidebarLayout3 from '@/layouts/SidebarLayout3'
import Tab from '@/components/_base/patterns/Tab'
import Tabs from '@/components/_base/patterns/Tabs'
import SeparateLine from '@/components/_base/patterns/SeparateLine'

/** Biblioteca */
import PmwTopProgress from '@solucoes/components-lib-tmp/src/components/elements/PmwTopProgress'
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import PmwImageUpload from '@solucoes/components-lib-tmp/src/components/patterns/PmwImageUpload'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import { PmwSelectionBoxScroll } from '@solucoes/components-lib-tmp/src/components/patterns/PmwSelectionBox'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import PmwInfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/PmwInfoTooltip'
import InfoPanel from '@solucoes/components-lib-tmp/src/components/patterns/InfoPanel'
import debounce from 'lodash.debounce'
import throttle from 'lodash.throttle'

export default {
  name: 'CreatePromotion',
  components: {
    AlertModal,
    PmwButton,
    PmwFormInput,
    Heading,
    Paragraph,
    SeparateLine,
    SidebarLayout3,
    Tab,
    Tabs,
    PmwImageUpload,
    SidebarBlock,
    PmwInfoTooltip,
    InfoPanel,
    PmwTopProgress,
    PmwSelectionBoxScroll
  },
  data() {
    return {
      loading: false,
      /** Caminho de pão */
      breadcrumb: [
        {
          label: 'Site Letsbook'
        },
        {
          label: 'Agrupador de promoções da rede ',
          url: '/promocoes',
          isSpa: true
        },
        {
          label: 'Criar agrupador de promoção da rede'
        }
      ],
      /** Input do nome */
      nameInput: [
        {
          idioma: 'pt-BR',
          nome: null,
          descricao: ''
        },
        {
          idioma: 'en-US',
          nome: null,
          descricao: ''
        },
        {
          idioma: 'es-ES',
          nome: null,
          descricao: ''
        }
      ],

      /** Input de imagem web */
      imgWeb: null,

      /** Input de imagem mobile */
      imgMobile: null,

      /** Input de tarifas selecionadas */
      selectedRates: [],

      /** Opções de tarifas a ser selecionada */
      options: [],

      /** Título da página */
      pageTitle: '',
      /** Exibição do botão de desativar */
      showDeactivateButton: true,
      /** Visualização da modal */
      showModal: false,
      /** Exibição do botão de reativar */
      promotionId: null,
      /** Status da promocao */
      status: true,
      /** Status da promoção */
      promoStatus: true,
      /** Imagem Exemplo */
      imageExample: imageExample,
      /** Abas com os idiomas */
      tabs: [
        {
          title: 'PT',
          label: 'Português',
          flag: pt,
          dataAttribute: 'pt-BR'
        },
        {
          title: 'EN',
          label: 'English',
          flag: en,
          dataAttribute: 'en-US'
        },
        {
          title: 'ES',
          label: 'Español',
          flag: es,
          dataAttribute: 'es-ES'
        }
      ],

      rateItems: [],
      searchText: null,
      updateParts: {
        viewStartIdx: 0,
        viewEndIdx: 0,
        visibleStartIdx: 0,
        visibleEndIdx: 0
      },
      isSearch: false,
      currentPage: null,
      loadOptions: false,
      /** Se não existem mais páginas na paginação */
      noMorePages: false
    }
  },
  computed: {
    formatRateItems() {
      return this.rateItems.reduce((accumulador, currentValue) => {
        accumulador.push({
          label: currentValue.nome,
          codigo: currentValue.codigo
        })

        currentValue.tarifas.forEach((item) => {
          item.nome = item.descricao
        })

        accumulador = [...accumulador, ...currentValue.tarifas]

        return accumulador
      }, [])
    },

    disabledSave() {
      /** Habilitação do botão de salvar */
      if (
        !this.nameInput.find((item) => item.idioma === 'pt-BR')?.nome ||
        this.imgWeb === null ||
        this.imgWeb === ''
      ) {
        return true
      }
      return false
    }
  },

  async created() {
    await this.getRates()

    if (this.$route.params.id) {
      await this.getOnePromotion()
      this.promotionId = this.$route.params.id
    } else {
      this.pageTitle = 'Criar agrupador de promoção da rede'
    }
  },

  methods: {
    /** Atualiza valores dos itens carregados e dos exibidos para o usuário
     * @param {Number} $viewStartIndex - Valor inicial carregado
     * @param {Number} $viewEndIndex - Valor final carregado
     * @param {Number} $visibleStartIndex - Valor inicial visível
     * @param {Number} $visibleEndIndex - Valor final visível
     */
    onUpdate(viewStartIndex, viewEndIndex, visibleStartIndex, visibleEndIndex) {
      this.updateParts.viewStartIdx = viewStartIndex
      this.updateParts.viewEndIdx = viewEndIndex
      this.updateParts.visibleStartIdx = visibleStartIndex
      this.updateParts.visibleEndIdx = visibleEndIndex

      if (viewEndIndex <= visibleEndIndex) {
        this.getPage()
      }

      if (
        !this.isSearch &&
        this.formatRateItems.length - this.updateParts.viewStartIdx < 10 &&
        !this.loadOptions
      ) {
        this.loadOptions = true
        this.getRates(+this.currentPage + 1, this.searchText)
      }
    },

    getPage: throttle(function() {
      this.getRates(+this.currentPage + 1, this.searchText)
    }, 300),

    /** Faz o filtro dos itens via back
     * @param {String} $event - Texto pesquisado
     */
    searchedItem($event) {
      this.searchText = $event
      $event ? (this.isSearch = true) : (this.isSearch = false)
      this.noMorePages = false
      this.currentPage = 1
      this.loadOptions = true
      this.rateItems = []
      this.getRates(1, $event)
    },

    /** Retorna o nome do idioma selecionado
     * @param {String} tabLanguage - Idioma da tab
     */
    displayNameValue(tabLanguage) {
      return this.nameInput.find((item) => item.idioma === tabLanguage)?.nome
    },

    /** Retorna a descrição do idioma selecionado
     * @param {String} tabLanguage - Idioma da tab
     */
    displayDescriptionValue(tabLanguage) {
      return this.nameInput.find((item) => item.idioma === tabLanguage)
        ?.descricao
    },

    /** Manipula a mudança de valores do nome
     * @param {String} $event - Texto do titulo do idioma
     * @param {String} tabLanguage - Idioma da tab atual
     */
    nameHandler: debounce(function($event, tabLanguage) {
      const langMatch = this.nameInput.find(
        (item) => item.idioma === tabLanguage
      )

      if (langMatch) {
        this.$set(langMatch, 'nome', $event)
      } else {
        this.nameInput.push({
          idioma: tabLanguage,
          nome: $event
        })
      }
    }, 200),

    /** Manipula a mudança de valores da descrição
     * @param {String} $event - Texto do titulo do idioma
     * @param {String} tabLanguage - Idioma da tab atual
     */
    descriptionHandler: debounce(function($event, tabLanguage) {
      const langMatch = this.nameInput.find(
        (item) => item.idioma === tabLanguage
      )

      if (langMatch) {
        this.$set(langMatch, 'descricao', $event)
      } else {
        this.nameInput.push({
          idioma: tabLanguage,
          descricao: $event
        })
      }
    }, 200),

    removeWebImage() {
      if (this.$route.params.id) {
        this.imgWeb = ''
      } else {
        this.imgWeb = null
      }
    },

    removeMobileImage() {
      this.imgMobile = null
    },

    async getOnePromotion() {
      this.loading = true
      /** Retorna os dados da promocao */
      await this.$promotionsBundler
        .get(this.$route.params.id)
        .then((response) => {
          const data = response.data

          this.promoStatus = data.ativo

          this.imgWeb = data.imagem

          this.imgMobile = data.imagemMobile

          data.idiomas.forEach((item) => {
            for (const key in item) {
              if (!item[key]) {
                item[key] = ''
              }
            }
          })

          this.nameInput = data.idiomas

          const returnData = response.data.flutuacoesTarifarias

          returnData.forEach((flutuacao) => {
            flutuacao.descricao = flutuacao.nome
          })

          this.selectedRates = returnData

          this.pageTitle =
            'Editando ' +
            data.idiomas.find((item) => item.idioma === 'pt-BR').nome
          this.breadcrumb[2].label = this.pageTitle
          this.status = data.ativo
        })
        .finally(() => {
          this.loading = false
        })
    },

    inactivatePromotion() {
      this.loading = true

      /** Desativa a promocao */
      const id = parseInt(this.$route.params.id)

      this.$promotionsBundler
        .disablePromotion({ promocoes: [id] })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de promoções desativado com sucesso'
          })

          this.$router.push({ path: '/promocoes' })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar agrupador de promoções'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Reativar usuário */
    reactivatePromotion(id) {
      this.loading = true

      this.$promotionsBundler
        .reactivatePromotion(id)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de promoção reativado com sucesso'
          })
          this.$router.push({ path: '/promocoes' })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao reativar agrupador de promoção'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Retorna dados do usuário
     * @param {Number} page - Número da página do filtro
     * @param {Number} name - Nome da tarifa a ser pesquisada da página do filtro
     * @param {Number} pageSize - Tamanho da página a ser pesquisada no filtro
     */
    async getRates(page = 1, name = null, pageSize = 2) {
      if (this.noMorePages) return

      this.currentPage = +page

      this.loading = true
      await this.$rate
        .getFluctuationRates({
          apenasTarifasPromocionais: true,
          apenasFlutuacoesAtivas: true,
          tamanhoPagina: pageSize,
          pagina: page,
          nome: !name ? null : name
        })
        .then(async (response) => {
          if (!response.data?.itens.length) {
            this.noMorePages = true
            return
          }

          this.currentPage = +response.data?.paginacao.paginaAtual

          await response.data?.itens?.forEach((item) => {
            const itemExists = this.rateItems.find(
              (existingItem) => existingItem.codigo === item.codigo
            )

            if (!itemExists) {
              this.rateItems.push(item)
            }
          })
        })
        .finally(() => {
          this.loading = false
          this.loadOptions = false
        })
    },

    savePromotion() {
      this.loading = true
      /** Salva os dados da promocao */

      /** Montando FormData para envio */
      const fieldsFD = new FormData()

      if (this.$route.params.id) {
        fieldsFD.append('codigo', parseInt(this.$route.params.id))
      }

      fieldsFD.append('imagem', this.imgWeb)
      fieldsFD.append('imagemMobile', this.imgMobile)
      fieldsFD.append('ativo', this.promoStatus)

      this.selectedRates.map((item) => {
        fieldsFD.append('tarifas', item.codigo)
      })

      this.nameInput = this.nameInput.filter(
        (item) => item.nome || item.descricao
      )

      this.nameInput.forEach((item, index) => {
        fieldsFD.append(`idiomas[${index}].idioma`, item.idioma)

        if (item.nome) {
          fieldsFD.append(`idiomas[${index}].nome`, item.nome ?? '')
        }

        if (item.descricao) {
          fieldsFD.append(`idiomas[${index}].descricao`, item.descricao ?? '')
        }
      })

      /** Edição */
      if (this.$route.params.id) {
        this.$promotionsBundler
          .updatePromotion(fieldsFD)
          .then(() => {
            this.$bus.$emit('show-alert-chip', {
              message: 'Agrupador de promoções atualizado com sucesso'
            })

            this.$router.push({ path: '/promocoes' })
          })
          .catch((error) => {
            this.$bus.$emit('show-alert-chip', {
              message: error.messages[0]
            })
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        /** Criação */
        this.$promotionsBundler
          .createPromotion(fieldsFD)
          .then(() => {
            this.$bus.$emit('show-alert-chip', {
              message: 'Agrupador de promoções cadastrado com sucesso'
            })

            this.$router.push({ path: '/promocoes' })
          })
          .catch((error) => {
            this.$bus.$emit('show-alert-chip', {
              message: error.messages[0]
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-text {
  font-size: font-size('size-small');
  color: $pmw-gray-dark;
}

.pmw-loader {
  @include pmw-loader();
}

.pmw-input-file--web::v-deep .pmw-preview-img-container {
  padding: 28px 0px;
  margin-top: 17px;
}

.pmw-input-file--web::v-deep .pmw-remove-file {
  margin-top: 25px;
}

::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
::v-deep .tabs--head {
  margin: 0px;
}
::v-deep .tabs--content {
  padding: 37px 0 40px 0;
}

.pmw-content {
  &-title {
    font-weight: 300;
    line-height: 21px;
    &__image {
      font-weight: 300;
      margin-bottom: 34px;
    }
  }
  &-text {
    font-size: 14;
    line-height: 21px;
    font-weight: 400;
    &__danger {
      color: #e04141;
    }
  }
}

::v-deep .selection-box--content {
  width: 460px;
}

::v-deep .selection-box--items {
  @include pmw-custom-scrollbar(
    8px,
    $pmw-gray-scrollbar,
    $pmw-white,
    $pmw-gray-darkest
  );
}

.pmw-selection-box {
  margin-top: 25px;

  &--active {
    color: $success;
  }
  &--disable {
    color: $error;
  }
}

.pmw-sidebar {
  &-buttons {
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}
.pmw-name-input {
  width: 441px;
  display: flex;
  float: left;
  margin-right: 50px;
  flex-direction: column;
  .character-count {
    margin-left: auto;
    padding-top: 7px;
    color: $gray-dark;
  }
}
.pmw-description-input {
  width: 441px;
  display: flex;
  flex-direction: column;
  .character-count {
    margin-left: auto;
    padding-top: 7px;
    color: $gray-dark;
  }
}

.pmw-bottom-action {
  display: flex;
  justify-content: space-between;
  &--button {
    width: 180px;
  }
}
.tab-title {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pmw-home {
  display: flex;
  margin: 0 auto;
}
.pmw-input-file {
  width: 100%;
  margin-right: 25px;
  &--web {
    float: left;
    flex-direction: column;
  }
  &--mobile {
    flex-direction: column;
  }
}

.pmw-page-actions {
  padding-top: 50px;
  &--button {
    width: 100%;
    cursor: pointer;

    & + .pmw-page-actions--button {
      margin-top: 10px;
    }
  }
}
.pmw-tooltip {
  &--text {
    margin-bottom: 5px;
    line-height: 18px;
  }
}
.pmw-bottom-bar {
  display: flex;
  justify-content: space-evenly;
  line-height: 22px;
  &-left {
    margin-right: 75px;
    font-weight: 500;
  }

  &-right {
    border: 1px solid $white;
    margin-left: 75px;
    min-width: 150px;
    max-width: 250px;
  }

  &-arrow {
    border: solid $white;
    border-width: 0 2px 2px 0;
    display: inline-block;
    margin-bottom: 2px;
    margin-left: 15px;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
}

.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;
      padding: 0 2px;

      &:focus {
        border-color: $pmw-blue;
      }
    }

    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
}
</style>
